import { ReactNode } from "react";
import { RenderWhen } from "../../../../common/infrastructure/components/RenderWhen";
import { IStudioReviewModel } from "../../models/reviewModels";
import { formatReviewDate } from "../../utils/reviewUtility";
import { StarRating } from "../StarRating/StarRating";
import styles from "./ReviewContent.module.scss";

interface IReviewContentProps {
  review: IStudioReviewModel;
  /** Shown in place of the comment when the review has only stars. */
  emptyCommentText?: string;
  /** Extra marks next to the author (e.g. the "Скрито" tag in the administration). */
  tags?: ReactNode;
}

/** One review as clients and the studio read it: stars, author, date, text, reply. */
export const ReviewContent = ({
  review,
  emptyCommentText,
  tags,
}: IReviewContentProps) => (
  <div className={styles.root}>
    <div className={styles.root_header}>
      <StarRating value={review.rating} />
      <span className={styles.root_header_name}>{review.reviewerName}</span>
      {tags}
      <span className={styles.root_header_date}>
        {formatReviewDate(review.createdOn)}
      </span>
    </div>

    <RenderWhen condition={!!review.comment || !!emptyCommentText}>
      <p
        className={
          review.comment ? styles.root_comment : styles.root_comment_empty
        }
      >
        {review.comment || emptyCommentText}
      </p>
    </RenderWhen>

    <RenderWhen condition={!!review.ownerReply}>
      <div className={styles.root_reply}>
        <span className={styles.root_reply_label}>Отговор от студиото:</span>
        <p className={styles.root_reply_text}>{review.ownerReply}</p>
      </div>
    </RenderWhen>
  </div>
);
